export default {
  H87: 'Piece | Pieces',
  MGM: 'mg',
  GRM: 'g',
  KGM: 'kg',
  MLT: 'ml',
  LTR: 'Litre',
  PTN: 'Portion | Portions',
  '1N': 'Count',
  CLT: 'cl',
  CMK: 'cm²',
  CMQ: 'cm³',
  CMT: 'cm',
  DLT: 'dl',
  DMK: 'dm²',
  DMQ: 'dm³',
  DMT: 'dm',
  E27: 'Dose | Doses',
  E55: 'Use | Uses',
  EA: 'Each',
  HLT: 'hl',
  KMT: 'km',
  KT: 'Kit | Kits',
  MMK: 'mm²',
  MMQ: 'mm³',
  MMT: 'mm',
  MTK: 'm²',
  MTQ: 'm³',
  MTR: 'Metre',
  PR: 'Pair',
  SET: 'Set | Sets',
  TNE: 'Tonne | Tonnes',
  U2: 'Tablet | Tablets',
  XRO: 'Roll | Rolls'
}



// WEBPACK FOOTER //
// ./src/i18n/en/uom.js